import { Button, Popconfirm, Space } from "antd";
import { DeleteFilled, EditFilled, CheckCircleTwoTone, CloseCircleTwoTone, RollbackOutlined } from "@ant-design/icons";

const propsColumnsPlatform = (limitPagination) => {
	return {
		size: "large",
		bordered: true,
		pagination: {
			position: ["none", "none"],
			pageSize: limitPagination,
		},
		className: "cmsTable",
	};
};

const columnsType = (editAction, deleteAction) => {
	return [
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			width: 240,
			render: (text) => <span>{text}</span>,
			sorter: (a, b) => {
				if (a.name < b.name) {
					return -1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			},
		},
		{
			title: "Esta activo",
			dataIndex: "isActive",
			key: "isActive",
			width: 120,
			render: (_, record) => {
				const status = record.isActive;
				return (
					<>
						<span className="flex justify-center items-center text-2xl">
							{status ? <CheckCircleTwoTone twoToneColor="green" /> : <CloseCircleTwoTone twoToneColor="red" />}
						</span>
					</>
				);
			},
			sorter: (a, b) => a.isActive - b.isActive,
		},
		{
			title: "Action",
			key: "action",
			width: 60,
			render: (_, record) => {
				const status = record.isActive;
				return (
					<Space size="middle">
						{status && (
							<Button
								type="text"
								icon={<EditFilled />}
								onClick={() => {
									editAction(record);
								}}
							/>
						)}
						<Popconfirm title={`${status ? "¿Seguro eliminar?" : "¿Volver activar?"}`} onConfirm={() => deleteAction(record.key)}>
							<Button type="text" icon={status ? <DeleteFilled /> : <RollbackOutlined />} />
						</Popconfirm>
					</Space>
				);
			},
		},
	];
};

export const columnsPlatforms = (editAction, deleteAction, limitPagination) => {
	const columns = columnsType(editAction, deleteAction);
	const props = propsColumnsPlatform(limitPagination);
	return {
		columns,
		props,
	};
};
